import { render, staticRenderFns } from "./MoveObject.vue?vue&type=template&id=4d7a0888&scoped=true"
import script from "./MoveObject.vue?vue&type=script&lang=js"
export * from "./MoveObject.vue?vue&type=script&lang=js"
import style0 from "./MoveObject.vue?vue&type=style&index=0&id=4d7a0888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7a0888",
  null
  
)

export default component.exports